<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      classeDespesasExtras(valor, opcao) {
        return valor == opcao ? 'fa-check-circle-o' : 'fa-circle-o';
      }
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Reserva de Hotel</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <dl v-if="configuracao.permitirSelecaoDespesasExtrasSolicitacaoCompraItemHotel">
            <dt>Autoriza despesas com extras?</dt>

            <dd class="row">
                <div class="col-sm-6">
                    <i class="fa" :class="classeDespesasExtras(item.despesasExtras, 1)"></i> Sim, exceto frigobar e bebidas alcóolicas. <br>
                </div>

                <div class="col-sm-6">
                    <i class="fa" :class="classeDespesasExtras(item.despesasExtras, '')"></i> Não <br>
                </div>
            </dd>
        </dl>

        <div class="row">
            <dl class="col-sm-6">
                <dt>Nome do hóspede</dt>
                <dd>{{ item.nomeHospede || '---' }}</dd>
            </dl>

            <dl class="col-sm-6">
                <dt>CPF do hóspede</dt>
                <dd>{{ item.cpfHospede || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-sm-6">
                <dt>Telefone</dt>
                <dd>{{ item.telefoneHospede || '---' }}</dd>
            </dl>

            <dl class="col-sm-6">
                <dt>E-mail</dt>
                <dd>{{ item.emailHospede || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <dt>Nome do hotel e contato / cidade e estado de destino</dt>
                <dd>{{ item.nomeHotel || '---' }}</dd>
            </dl>

            <dl class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>


        <div class="row">
            <dl class="col-sm-3">
                <dt>Data do check in</dt>
                <dd>{{ item.dataCheckin | formatarNumeroEmData }}</dd>
            </dl>

            <dl class="col-sm-3">
                <dt>Hora do check in</dt>
                <dd>{{ item.horaCheckin }}</dd>
            </dl>

            <dl class="col-sm-3">
                <dt>Data do check out</dt>
                <dd>{{ item.dataCheckout | formatarNumeroEmData }}</dd>
            </dl>

            <dl class="col-sm-3">
                <dt>Hora do check out</dt>
                <dd>{{ item.horaCheckout }}</dd>
            </dl>
        </div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaReservaDeHotel.vue